import { parseBooleanEnv } from './utils';

export const environment = {
  apiBaseUrl: 'https://dev.api.sbv360.com',
  reportsApiUrl: 'https://report-generator-api-dev.azurewebsites.net',
  chatPublicKey: '7j2r5n773wxu',
  environment: 'dev',
  mixpanelToken: undefined as string | undefined,
  enablePBJ: parseBooleanEnv(process.env.NX_FEATURE_FLAG_PBJ_ENABLED, true),
};
